import React, {useEffect, useState} from "react";
import "./Banner.scss"
import product1 from "./img/product1.png"
import product2 from "./img/product2.png"
import product3 from "./img/product3.png"
import product4 from "./img/product4.png"
import {withRouter} from 'react-router-dom';
import intl from "react-intl-universal";

export default withRouter(function Banner({history}) {
    let timer = null;
    let scale, slide, txtPositionX, txtPositionY, scaleImg, opacityImg;
    const [innerH, setInnerH] = useState(0);

    useEffect(() => {
        let swiper = new window.Swiper(".apple-banner .swiper-container", {
            autoplay: 4e3,
            speed: 1e3,
            loop: !0,
            runCallbacksOnInit: !1,
            watchSlidesProgress: !0,
            pagination: ".apple-banner .swiper-pagination",
            paginationClickable: !0,
            paginationBulletRender: function (a, b, c) {
                return '<li class="' + c + '"><span><i></i></span></li>'
            },
            nextButton: ".swiper-button-next.main-banner",
            prevButton: ".swiper-button-prev.main-banner",


            onInit: function(swiper){ //Swiper2.x的初始化是onFirstInit
                window.swiperAnimateCache(swiper); //隐藏动画元素
                window.swiperAnimate(swiper); //初始化完成开始动画
            },
            onSlideChangeEnd: function(swiper){
                window.swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
            },
            onSlideChangeStart: function (a) {
                if (a.autoplaying) {
                    a.bullets.eq(a.realIndex - 1).addClass("replace");
                    a.bullets.eq(a.realIndex - 1).removeClass("current firsrCurrent");
                    a.bullets.eq(a.realIndex).addClass("current");
                    0 == a.realIndex && a.bullets.removeClass("replace");
                }
            },
            onAutoplayStop: function (a) {
                a.$(".autoplay").removeClass("autoplay")
            },
            onClick: function (s) {
                if (s.clickedSlide) {
                    let path = s.clickedSlide.getAttribute("date-href");
                    history.push(`/product/${path}`);
                }
            }
        });
        for (let b = 0; b < swiper.slides.length; b++) swiper.slides[b].style.zIndex = b;

        timer = setTimeout(() => {
            swiper.bullets.eq(0).addClass("firsrCurrent")
        }, 100);

        // 重置高度
        setInnerH(window.innerHeight);

        return () => timer && clearTimeout(timer)
    }, []);

    return <>
        <div className="apple-banner" style={{height: innerH + 'px'}}>
            <div className="swiper-container swiper-container-horizontal" style={{height: innerH + 75 + 'px'}}>
                <div className="swiper-wrapper">
                    <div className="swiper-slide slide4" date-href="R-SmartPro">
                        <div className="ani product-img" swiper-animate-effect="zoomIn" swiper-animate-duration="0.8s"
                             swiper-animate-delay="0s">
                            <img src={product4}/>
                        </div>
                        <div className="ani title txt" swiper-animate-effect="fadeInRight" swiper-animate-duration="0.8s"
                             swiper-animate-delay="0s">
                            {/*iPhone*/}
                            <br/>
                            <p>
                                <span className="en-title">{intl.get('Pro')}</span>
                            </p>
                            <span className="en-title"> {intl.get('ggzly')}</span>
                            <br/>
                            <div className="sub-title">
                                <p>
                                    <i className="icon-glyph-207 medium cus-font-correct"></i>
                                    <span className="sub-text">{intl.get('ggzly-advan1')}</span>
                                </p>
                                <p>
                                    <i className="icon-glyph-207 medium cus-font-correct"></i>
                                    <span className="sub-text">{intl.get('ggzly-advan2')}</span>
                                </p>
                                <p>
                                    <i className="icon-glyph-207 medium cus-font-correct"></i>
                                    <span className="sub-text">{intl.get('ggzly-advan3')}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-slide slide1" date-href="MCure6">
                        <div className="ani product-img" swiper-animate-effect="zoomIn" swiper-animate-duration="0.8s"
                           swiper-animate-delay="0s">
                            <img src={product1}/>
                        </div>
                        <div className="ani title txt" swiper-animate-effect="fadeInRight" swiper-animate-duration="0.8s"
                             swiper-animate-delay="0s">
                            {/*iPhone*/}
                            <br/>
                            <span className="en-title">M-Cure 6</span>
                            <br/>
                            {intl.get('guangguhua')}
                            <div className="sub-title">
                                <p>
                                    <i className="icon-glyph-207 medium cus-font-correct"></i>
                                    <span className="sub-text">{intl.get('guangguhua-advan1')}</span>
                                </p>
                                <p>
                                    <i className="icon-glyph-207 medium cus-font-correct"></i>
                                    <span className="sub-text">{intl.get('guangguhua-advan2')}</span>
                                </p>
                                <p>
                                    <i className="icon-glyph-207 medium cus-font-correct"></i>
                                    <span className="sub-text">{intl.get('guangguhua-advan3')}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="swiper-slide slide2" date-href="UltraR6">
                        <div className="ani product-img" swiper-animate-effect="zoomIn" swiper-animate-duration="0.8s"
                           swiper-animate-delay="0s">
                            <img src={product2}/>
                        </div>
                        <div className="ani title txt" swiper-animate-effect="fadeInRight" swiper-animate-duration="0.8s"
                             swiper-animate-delay="0s">
                            {/*iPhone*/}
                            <br/>
                            <span className="en-title">Ultra R6</span>
                            <br/>
                            {intl.get('UltraR6')}
                            <div className="sub-title">
                                <p>
                                    <i className="icon-glyph-263 medium cus-font-correct"></i>
                                    <span className="sub-text">{intl.get('UltraR6-advan1')}</span></p>
                                <p>
                                    <i className="icon-glyph-263 medium cus-font-correct"></i>
                                    <span className="sub-text">{intl.get('UltraR6-advan2')}</span>
                                </p>
                                <p>
                                    <i className="icon-glyph-263 medium cus-font-correct"></i>
                                    <span className="sub-text">{intl.get('UltraR6-advan3')}</span>
                                </p>
                            </div>
                        </div>
                        {/*<h2 className="homepage-headline txt">R-Smart Plus</h2>*/}
                    </div>
                    <div className="swiper-slide slide3" date-href="RPEX9">
                        <div className="ani product-img" swiper-animate-effect="zoomIn" swiper-animate-duration="0.8s"
                           swiper-animate-delay="0s">
                            <img src={product3}/>
                        </div>
                        <div className="ani title txt" swiper-animate-effect="fadeInRight" swiper-animate-duration="0.8s"
                             swiper-animate-delay="0s">
                            <span className="en-title">RPEX</span>
                            <span className="large-title">9</span>
                            <br/>
                            {intl.get('celiangyi')}
                            <div className="sub-title">
                                <p>
                                    <i className="icon-glyph-10 medium cus-font-correct"></i>
                                    <span className="sub-text">{intl.get('celiangyi-advan1')}</span></p>
                                <p>
                                    <i className="icon-glyph-10 medium cus-font-correct"></i>
                                    <span className="sub-text">{intl.get('celiangyi-advan2')}</span>
                                </p>
                                <p>
                                    <i className="icon-glyph-10 medium cus-font-correct"></i>
                                    <span className="sub-text">{intl.get('celiangyi-advan3')}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="swiper-button-prev main-banner"><span></span></div>
                <div className="swiper-button-next main-banner"><span></span></div>
                <ul className="swiper-pagination autoplay swiper-pagination-clickable swiper-pagination-bullets">
                    <li className="swiper-pagination-bullet"><span><i></i></span></li>
                    <li className="swiper-pagination-bullet"><span><i></i></span></li>
                    <li className="swiper-pagination-bullet"><span><i></i></span></li>
                    <li className="swiper-pagination-bullet"><span><i></i></span></li>
                </ul>
            </div>
        </div>
    </>
})
